import StageSelect, { TMode } from 'components/StageSelect'
import { useNavigate } from 'react-router-dom'

import { MarkX } from '@rushable/icons'
import Button from 'components/Button'
import Switch from 'components/Switch'
import { QuickSearchLocation } from 'components/Select'

import { useAppSelector } from 'redux/hooks'

export type TAccountsFilterProps = {
  setOpen: (arg1: boolean) => void
  handleModeChange: (arg1: TMode) => void
  handleOnlyChange: (arg1: boolean) => void
  clearFilter: () => void
}

export default function AccountsFilter({
  setOpen,
  handleModeChange,
  handleOnlyChange,
  clearFilter,
}: TAccountsFilterProps) {
  const navigate = useNavigate()
  const authMap = useAppSelector(state => state.auth.authMap)
  const { total, onlySelf, filterCount, mode, counts } = useAppSelector(
    state => state.account,
  )
  return (
    <div className='flex justify-between'>
      <div className='flex'>
        <StageSelect
          mode={mode}
          count={[
            counts.all,
            counts.draft + counts.signup,
            counts.onboarding,
            counts.live,
            counts.canceling,
            counts.churned,
            counts.withdrawal,
          ]}
          onChange={newMode => handleModeChange(newMode)}
        />
        <Button
          className='ml-4'
          theme='outlined'
          color='secondary'
          onClick={() => setOpen(true)}
        >
          Filter Restaurant
        </Button>
        {filterCount > 0 && (
          <div className='ml-4 flex items-center'>
            <span className='pr-4 text-light-300'>
              {total} results from {filterCount} conditions
            </span>
            <Button
              theme='text'
              color='secondary'
              iconBefore={<MarkX size={12} className='text-light-700' />}
              onClick={clearFilter}
            >
              CLEAR
            </Button>
          </div>
        )}
        <QuickSearchLocation
          className='ml-4 w-60'
          placeholder='Quick search: brand, phone'
          onClickOption={v => {
            navigate(`/accounts/detail/${v}`)
          }}
        />
      </div>
      <div className='flex'>
        <Switch
          checked={onlySelf === '1' ? true : false}
          onChange={e => {
            handleOnlyChange(e.target.checked)
          }}
        >
          Show my accounts only
        </Switch>
        {authMap?.roleId! < 20 && (
          <Button
            className='ml-6'
            theme='outlined'
            color='secondary'
            as='Link'
            href='/accounts/group'
          >
            Group Signup
          </Button>
        )}
        {authMap?.roleId! < 20 || authMap?.crmTeamId === 3 || authMap?.crmTeamId === 4 ? (
          <Button
            className='ml-4'
            theme='contained'
            color='secondary'
            as='Link'
            href='/accounts/detail/create'
          >
            Initiate Signup
          </Button>
        ) : null}
      </div>
    </div>
  )
}
